import React from 'react';

import { NoticeBar } from '@eika/notice-bar';

import { useConfig } from './config';

const SitecorePageComponent = () => {
    const { modalTitle, noticeMessage, updatedDate, id, showMessageButton, closeMessageButton } = useConfig();
    const sitecoreId = id || '1234';

    return (
        <div>
            <NoticeBar
                modalTitle={modalTitle}
                noticeMessage={noticeMessage}
                updatedDate={updatedDate}
                id={sitecoreId}
                showMessageButton={showMessageButton}
                closeMessageButton={closeMessageButton}
            />
        </div>
    );
};

export default SitecorePageComponent;
